import config from "./config";

const API = config.API_URL;

const fetchApi = async (url: string, options: any) => {
  try {
    const resp = await window.fetch(url, options);
    if (!resp.ok) {
      throw resp.status;
    }
    return await resp.json();
  } catch (e) {
    console.error("Report template API error:", e);
  }
};

export const getReportTemplates = () => {
  return fetchApi(API + "report-templates", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getReportTemplate = (id: string) => {
  return fetchApi(API + `report-template/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createReportTemplate = (template: {
  name: string;
  settings?: any;
}) => {
  return fetch(API + "report-templates", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(template),
  });
};

export const updateReportTemplate = (
  id: string,
  template: {
    name?: string;
    settings?: any;
  },
) => {
  return fetch(API + `report-template/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(template),
  });
};

export const updateReportTemplateOrder = (order: [string, number][]) => {
  return fetch(API + `report-template/order/`, {
    method: "Post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(order),
  });
};

export const deleteReportTemplate = (id: string) => {
  return fetch(API + `report-template/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
